import { useSelector } from "react-redux";
import { isEmpty } from "../utils/helpers";
import useQuery from "./useQuery";

const useTenant = () => {
  const tenantId = useSelector(state => state?.jazasoft?.auth?.tenant?.tenantId);
  const { data: tenantList = {} } = useQuery(!isEmpty(tenantId) && { url: "tenants", params: { search: `tenantId==${tenantId}` } });
  return tenantList[0];
};

export default useTenant;
